export const statusOptions = {

    data() {
        return { 
          statusOptions: [
          { value: '01', text: 'New' },
          { value: '02', text: 'Approved' },
          { value: '03', text: 'Disapproved' },
          { value: '04', text: 'Assigned' },
          { value: '05', text: 'Hold' },
          { value: '06', text: 'Audit' },
          { value: '07', text: 'Draft Posting' },    
          { value: '08', text: 'Posted' },
          { value: '09', text: 'Screen Applicant' },
          { value: '10', text: 'Roster with Manager/Interview' },
          { value: '11', text: 'Salary Review' },
          { value: '12', text: 'Offered' },
          { value: '13', text: 'Background Check Pending' },
          { value: '14', text: 'Re-post' },
          { value: '15', text: 'Complete' },
          { value: '16', text: 'Pre Offer Review' },
          { value: '17', text: 'Cancelled' },
          { value: '18', text: 'RDC Submission' },
          { value: '19', text: 'RDC Candidate Selection' },
          { value: '20', text: 'RDC Onboarding' },
          { value: '36', text: 'Reference Check' },
          { value: '37', text: 'Pre-Onboarding' },
          { value: '35', text: 'Make Offer' },
          { value: '23', text: 'Create PCN' },
          { value: '24', text: 'Update PCN' },
          { value: '38', text: 'Closeout Payroll Review' },
      ],

          staffingStatusOptions: [
            { value: '01', text: 'New' },
            { value: '02', text: 'Approved' },
            { value: '04', text: 'Assigned' },
            { value: '33', text: 'Requester Review' },
            { value: '06', text: 'Audit' },
            { value: '07', text: 'Draft Posting' },
            { value: '34', text: 'Posting Review' },
            { value: '08', text: 'Posted' },
            { value: '09', text: 'Screen Applicant' },
            { value: '10', text: 'Roster with Manager/Interview' },
            { value: '16', text: 'Pre Offer Review' },
            { value: '11', text: 'Salary Review' },
            { value: '35', text: 'Make Offer' },
            { value: '12', text: 'Offered' },
            { value: '13', text: 'Background Check Pending' },
            { value: '36', text: 'Reference Check' },
            { value: '37', text: 'Pre-Onboarding' },
            { value: '15', text: 'Complete' },
            { value: '05', text: 'Hold' },
            { value: '17', text: 'Cancelled' },
            { value: '38', text: 'Closeout Payroll Review' },
          ],
          
          hiringStatusOptions: [
            { value: '01', text: 'New' },
            { value: '02', text: 'Approved' },
            { value: '04', text: 'Assigned' },
            { value: '06', text: 'Audit' },
            { value: '07', text: 'Draft Posting' },
            { value: '08', text: 'Posted' },
            { value: '09', text: 'Screen' },
            { value: '10', text: 'Interview' },
            { value: '11', text: 'Salary Review' },
            { value: '12', text: 'Offered' },
            { value: '13', text: 'Background Check' },
            { value: '38', text: 'Closeout Payroll Review' },
          ],
          hrmAdminOptions: [
            { value: '01', text: 'New' },
            { value: '02', text: 'Approved' },
            { value: '03', text: 'Disapproved' },
            { value: '04', text: 'Assigned' },
            { value: '05', text: 'Hold' },
            { value: '06', text: 'Audit' },
            { value: '07', text: 'Draft Posting' },
            { value: '08', text: 'Posted' },
            { value: '09', text: 'Screen Applicant' },
            { value: '10', text: 'Roster with Manager/Interview' },
            { value: '11', text: 'Salary Review' },
            { value: '12', text: 'Offered' },
            { value: '13', text: 'Background Check Pending' },
            { value: '15', text: 'Complete' },
            { value: '16', text: 'Pre Offer Review' },
            { value: '17', text: 'Cancelled' },
            { value: '33', text: 'Requester Review' },
            { value: '34', text: 'Posting Review' },
            { value: '35', text: 'Make Offer' },
            { value: '36', text: 'Reference Check' },
            { value: '37', text: 'Pre-Onboarding' },
            { value: '38', text: 'Closeout Payroll Review' },

          ],

    }
    }

  }
